import {flow, Instance, types} from 'mobx-state-tree';
import { UploadFilesService } from '../upload/UploadFilesService';
import { ApiService } from '../api/ApiService';
import { FileStates } from '../shop/ShopHistoryStorage';
import { ActivityTypes } from '../shop/ActivityPricesStorage';
import { Video } from '../inspection/Video';
import { CreditBalanceStorage } from '../shop/CreditBalanceStorage';

export interface IServiceStorageEnv {
    uploadFilesService: UploadFilesService;
    api: ApiService,
    creditBalanceStorage: CreditBalanceStorage;
}

export const ServiceModel = types.model({
    fileId: types.optional(types.frozen<number | undefined>(), undefined),
    fileGuid: types.optional(types.frozen<string | undefined>(), undefined),
    video: types.optional(types.frozen<Video | undefined>(), undefined),
    activityType: types.frozen<ActivityTypes>(),
    isConverted: types.optional(types.boolean, false),
    isLoading: types.optional(types.boolean, false),
    status: types.optional(types.frozen<FileStates>(), FileStates.Running),
    errorMessage: types.optional(types.frozen<string | null>(), null)
}).extend(self => {
    return {
        actions: {
            clear: () => {},
            runService: flow(function* () {}),
            runAfterUpload: flow(function* () {}),
            request: flow(function* () {})
        }
    }
}).actions((self) => ({
    setLoading(loading: boolean) {
        self.isLoading = loading;
    },
    load: flow(function* () {
        if (self.fileId === undefined) return;
        self.isLoading = true;
        yield self.request();
        self.isLoading = false;
    }),
    startService: flow(function* () {
        if (self.fileId === undefined) return;
        self.isLoading = true;
        yield self.runService();
        self.isLoading = false;
    }),
    setFileId(fileId: number) {
        self.fileId = fileId;
    },
    setFileGuid(fileGuid: string) {
        self.fileGuid = fileGuid;
    },
    getFileState(success: boolean, failed: string, progress: boolean) {
        self.errorMessage = failed;
        if (success) return FileStates.Success;
        if (failed !== null && failed !== "") return FileStates.Failed;
        if (progress) return FileStates.Running;
        return FileStates.None
    }
})).extend(self => {
    return {
        actions: {
            redo: flow(function* () {
                yield self.startService();
                yield self.load();
            }),
            new: flow(function* () {
                self.clear();
            })
        }
    }
}).actions((self) => ({
    onServiceFinished: flow(function* (id: number) {
        if (id == self.fileId) yield self.load();
    })
}))

export type ServiceStorage = Instance<typeof ServiceModel>;